import React from "react";
import { useNavigate } from "react-router-dom";

const AdminExam = () => {
    const navigate = useNavigate();

    return (
        <div className="container mx-auto py-10">
            <h1 className="text-3xl font-bold text-teal-600 mb-6 text-center">
                Manage Exam Papers
            </h1>
            <p className="text-lg text-gray-600 mb-8 text-center">
                Choose the exam board to manage past papers and resources.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* AQA Button */}
                <button
                    onClick={() => navigate("/adminaqa")}
                    className="bg-blue-500 text-white font-semibold p-6 rounded-lg shadow-md hover:bg-blue-600 transition duration-300"
                >
                    <h2 className="text-2xl">AQA</h2>
                    <p>Manage AQA past papers and resources.</p>
                </button>

                {/* Edexcel Button */}
                <button
                    onClick={() => navigate("/adminedexcel")}
                    className="bg-teal-500 text-white font-semibold p-6 rounded-lg shadow-md hover:bg-teal-600 transition duration-300"
                >
                    <h2 className="text-2xl">Edexcel</h2>
                    <p>Manage Edexcel past papers and resources.</p>
                </button>

                {/* OCR Button */}
                <button
                    onClick={() => navigate("/adminocr")}
                    className="bg-purple-500 text-white font-semibold p-6 rounded-lg shadow-md hover:bg-purple-600 transition duration-300"
                >
                    <h2 className="text-2xl">OCR</h2>
                    <p>Manage OCR past papers and resources.</p>
                </button>
            </div>
        </div>
    );
};

export default AdminExam;
